export const handleOpenReport = async (resourceID: string): Promise<void> => {
  let reportWindow: Window | null;

  try {
    const config = await (await fetch("./config.json")).json();
    reportWindow = window.open(`${config.resources.viewer}${resourceID}&token=${config.accessToken}`, "_blank");
  } catch (error) {
    throw new Error("Falha ao abrir o relatório. Por favor, tente novamente mais tarde.");
  }

  if (!reportWindow) {
    throw new Error(
      "O navegador bloqueou a abertura do relatório em uma nova aba. Permita pop-ups para este site e tente novamente."
    );
  }
};
